export const AuthenticationTranslations = {
    authenticationTranslations : {
        forgotPassword : 'Forgot password',
        description: 'Enter the email you signed up with and we will send you a new password.',
        confirmation: {
            message: 'We\'ve sent a temporary password to your email address. Please check your inbox for the email titled "Password Reset".',
        },
        accountConfirm: {
            heading: 'Account confirmation',
            description: 'Set a password for your newly confirmed account.',
            success: 'Your account has been confirmed and your password has been set.',
            failure: 'Failed to confirm your account and set password',
            already_confirmed: 'Your account has already been confirmed',
            submit: 'Set password',
        },
        passwordReq: {
            minLength: 'Password must be at least 8 characters long',
            confirmMatch: 'Password confirmation must match'
        }
    }
}
